import { TCustomer, THumanName } from '../core/user/types/customer.type'

const UserDescriptions = [
    {
        description: 'Active',
        api: {
            type: 'Associate',
            status: 'Active',
            priceLevel: 'wholesale_price'
        },
        shortStatus: 'A'
    },
    {
        description: 'Pending',
        api: {
            type: 'Associate',
            status: 'Pending',
            priceLevel: 'wholesale_price'
        },
        shortStatus: 'B'
    },
    {
        description: 'Customer',
        api: {
            type: 'Customer',
            status: 'Active',
            priceLevel: 'retail_price'
        },
        shortStatus: 'C'
    },
    {
        description: 'Balance (CHE, DEU), Defective (JP)',
        api: {
            type: 'Associate',
            status: 'Defective',
            priceLevel: null
        },
        shortStatus: 'D'
    },
    {
        description: 'Employee',
        api: {
            type: 'Employee',
            status: 'Active',
            priceLevel: 'employee_price'
        },
        shortStatus: 'E'
    },
    {
        description: 'Family Pricing',
        api: {
            type: 'Family',
            status: 'Active',
            priceLevel: 'employee_price'
        },
        shortStatus: 'F'
    },
    {
        description: 'Wholesale Customer',
        api: {
            type: 'WholesaleCustomer',
            status: 'Active',
            priceLevel: 'wholesale_price'
        },
        shortStatus: 'H'
    },
    {
        description: 'Performance Labs',
        api: {
            type: 'Performance Labs',
            status: 'Active',
            priceLevel: 'wholesale_price'
        },
        shortStatus: 'L'
    },
    {
        description: 'Member',
        api: {
            type: 'Member',
            status: 'Active',
            priceLevel: 'member'
        },
        shortStatus: 'M'
    },
    {
        description: 'Preferred Customer',
        api: {
            type: 'PreferredCustomer',
            status: 'Active',
            priceLevel: 'preferred_price'
        },
        shortStatus: 'P'
    },
    {
        description: 'Retired',
        api: {
            type: 'Associate',
            status: 'Retired',
            priceLevel: null
        },
        shortStatus: 'R'
    },
    {
        description: 'Suspended',
        api: {
            type: 'Associate',
            status: 'Suspended',
            priceLevel: null
        },
        shortStatus: 'S'
    },
    {
        description: 'Terminated',
        api: {
            type: 'Associate',
            status: 'Terminated',
            priceLevel: null
        },
        shortStatus: 'T'
    }
]

const getStatus = (customer: TCustomer) => {
    const statuses = Object.values(UserDescriptions)
    const status = statuses.find(status => status.api.status === customer.status && status.api.type === customer.type)
    console.log('customer', customer.status, customer.type)
    return status?.shortStatus || 'C'
}

const getCustomerStatus = (cStatus: string, cType: string) => {
    const statuses = Object.values(UserDescriptions)
    const customerStatus = statuses.find(status => status.api.status === cStatus && status.api.type === cType)

    return customerStatus?.shortStatus || ''
}

const getFullName = (customer: TCustomer, isNative: boolean = false) => {
    if (!isNative) {
        if (customer.humanName.fullName) {
            return customer.humanName.fullName
        }

        let fullName = ''
        if (customer.humanName.firstName) {
            fullName += customer.humanName.firstName
        }
        if (customer.humanName.lastName) {
            fullName += ` ${customer.humanName.lastName}`
        }
        return fullName
    } else {
        // etlV2/onself returns the native-script name under a locale-suffixed key
        // (e.g. `fullName@ja`); some responses use `nativeName` instead.
        if (customer.humanName.nativeName) {
            return customer.humanName.nativeName
        }
        let fullName = ''
        Object.keys(customer.humanName).forEach(key => {
            if (key.includes('fullName@')) {
                fullName = customer.humanName[key as keyof typeof customer.humanName] as string
            }
        })
        return fullName
    }
}

const getHumanName = (humanName: THumanName, isNative: boolean = false) => {
    if (!isNative) {
        if (humanName.fullName) {
            return humanName.fullName
        }

        let fullName = ''
        if (humanName.firstName) {
            fullName += humanName.firstName
        }
        if (humanName.lastName) {
            fullName += ` ${humanName.lastName}`
        }
        return fullName
    } else {
        // etlV2/onself returns the native-script name under a locale-suffixed key
        // (e.g. `fullName@ja`); some responses use `nativeName` instead.
        if (humanName.nativeName) {
            return humanName.nativeName
        }
        let fullName = ''
        Object.keys(humanName).forEach(key => {
            if (key.includes('fullName@')) {
                fullName = humanName[key as keyof typeof humanName] as string
            }
        })
        return fullName
    }
}

/**
 * The registered native-script name (JP/KR/TW …), or '' when the account has none.
 * `fullName@en` is a latin name, not a native one, so it is skipped — accounts that
 * only carry it are treated as having no native name.
 */
const getNativeName = (customer: TCustomer) => {
    const humanName = customer?.humanName
    if (!humanName) return ''
    if (humanName.nativeName) return humanName.nativeName
    const nativeKey = Object.keys(humanName).find(key => key.startsWith('fullName@') && key !== 'fullName@en')
    return nativeKey ? (humanName[nativeKey as keyof typeof humanName] as string) || '' : ''
}

/**
 * The name to ship under: native-script when the account has one, latin otherwise.
 * Driven by the account's own data, so markets with no native name are unchanged.
 */
const getShipToName = (customer: TCustomer) => {
    if (!customer?.humanName) return ''
    return getNativeName(customer) || getFullName(customer)
}

const getPhoneNumber = (customer: TCustomer) => {
    if (customer.mobilePhone) {
        return customer.mobilePhone
    } else if (customer.homePhone) {
        return customer.homePhone
    } else if (customer.workPhone) {
        return customer.workPhone
    } else {
        return ''
    }
}

export const customerHelpers = {
    getStatus,
    getFullName,
    getNativeName,
    getShipToName,
    getHumanName,
    getCustomerStatus,
    getPhoneNumber
}
